/**
 * @file contractFulfilment.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-17
 * @modified 2026-09-17
 * @description Mark a contract fulfilled, or unmark it, from a pricing table's
 *              right-click and three-dots menus. The override shows the contract
 *              as FULFILLED whatever its tonnage says. A contract in a product
 *              group is marked as a whole — the server changes every member.
 */

import { API_URL } from '../config';

async function patch(url, body) {
  const r = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body)
  });
  if (!r.ok) {
    const data = await r.json().catch(() => ({}));
    throw new Error(data.error || `HTTP ${r.status}`);
  }
  return r.json();
}

/** Blends, compounds, minerals, bags, other and spot (pricing.customer_contracts). */
export const setContractsFulfilled = (ids, isFulfilled) =>
  patch(`${API_URL}/api/pricing/contracts/fulfilled`, { ids, is_fulfilled_override: !!isFulfilled });

/** Straights: the override lives on the parent contract. */
export const setStraightsContractFulfilled = (id, isFulfilled) =>
  patch(`${API_URL}/api/pricing/straights-contracts/${id}/fulfilled`, { is_fulfilled_override: !!isFulfilled });

/**
 * The menu item. `fulfilled` is whether the contract is marked now; `onToggle`
 * does the change. Same shape as every other RowActionsMenu / TableContextMenu
 * action.
 */
export const fulfilledAction = ({ fulfilled, onToggle, subject = 'contract' }) => ({
  key: 'fulfilled',
  icon: fulfilled ? 'remove_done' : 'task_alt',
  label: fulfilled ? 'Unmark fulfilled' : 'Mark fulfilled',
  title: fulfilled
    ? `Stop showing this ${subject} as fulfilled — its tonnage decides again`
    : `Show this ${subject} as fulfilled, whatever its tonnage says`,
  onClick: onToggle
});
